/* eslint-disable */
import axios from 'axios';
import { API_BASE_URL } from 'src/configs/AppConfig';
import Utils from 'src/utils';

// Keycloak API response types
export type KeycloakLoginResponse = {
  success: boolean;
  message: string;
  data: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
};

export type KeycloakBaseResponse = {
  success: boolean;
  message: string;
};

// Auth payload types
export type AuthForgetPass = {
  email: string;
};

export type AuthForgetConfirmPass = {
  email: string;
  confirmationCode: string;
  password: string;
};

export type ConfirmAuth = {
  email: string;
  confirmationCode: string;
};

export type AuthLogIn = {
  email: string;
  password: string;
};

export type AuthChangePassword = {
  email: string;
  newPassword: string;
  oldPassword: string;
};

export type IConfirmNewPassword = {
  username: string;
  newPassword: string;
  confirmationCode: string;
};

export type IChangePasswordParams = Omit<AuthChangePassword, 'email'>;

export type AuthReg = {
  username: string;
  lastName: string;
  firstName: string;
  password: string;
  email: string;
  phoneNumber: number;
};

type AuthMethod = {
  createAccount: (payload: AuthReg) => Promise<any>;
  loginAccount: (payload: AuthLogIn) => Promise<any>;
  confirmEmail: (payload: ConfirmAuth) => Promise<any>;
  resendSignUpOTP: (username: string) => Promise<any>;
  forgotPassword: (payload: AuthForgetPass) => Promise<any>;
  forgotPasswordSubmit: (payload: AuthForgetConfirmPass) => Promise<any>;
  changePassword: (payload: AuthChangePassword) => Promise<any>;
  confirmResetPassword: (payload: IConfirmNewPassword) => Promise<any>;
  currentUserPoolInfo: () => Promise<any>;
};

// Axios instance for public auth requests (no token needed)
const authAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const authService = <AuthMethod>{};

// POST /users/v1/auth/login
authService.loginAccount = function (payload: AuthLogIn) {
  return authAxios.post<KeycloakLoginResponse>('/users/v1/auth/login', {
    username: Utils.convertPhoneToISO(payload.email),
    password: payload.password,
  });
};

// POST /users/v1/auth/resetPassword  (request temporary reset)
authService.forgotPassword = function (payload: AuthForgetPass) {
  return authAxios.post<KeycloakBaseResponse>('/users/v1/auth/resetPassword', {
    username: payload.email,
    temporary: true,
  });
};

// POST /users/v1/auth/resetPassword  (submit new password)
authService.forgotPasswordSubmit = function (payload: AuthForgetConfirmPass) {
  return authAxios.post<KeycloakBaseResponse>('/users/v1/auth/resetPassword', {
    username: payload.email,
    password: payload.password,
    temporary: false,
  });
};

// POST /users/v1/auth/changePassword
authService.changePassword = function (payload: AuthChangePassword) {
  return authAxios.post<KeycloakBaseResponse>('/users/v1/auth/changePassword', {
    username: Utils.convertPhoneToISO(payload.email),
    oldPassword: payload.oldPassword,
    newPassword: payload.newPassword,
  });
};

// POST /users/v1/auth/resetPassword  (confirm new password flow)
authService.confirmResetPassword = function (payload: IConfirmNewPassword) {
  return authAxios.post<KeycloakBaseResponse>('/users/v1/auth/resetPassword', {
    username: payload.username,
    password: payload.newPassword,
    temporary: false,
  });
};

// Stub methods kept for backward compatibility
authService.createAccount = () => Promise.resolve({});
authService.confirmEmail = () => Promise.resolve({});
authService.resendSignUpOTP = async () => Promise.resolve({});
authService.currentUserPoolInfo = () => Promise.resolve({});

export default authService;
